import { render, staticRenderFns } from "./oil-volume-change-chart.vue?vue&type=template&id=9090bd46"
import script from "./oil-volume-change-chart.vue?vue&type=script&lang=js"
export * from "./oil-volume-change-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports